import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import styles from './roundButton.scss';

export function RoundButton({ icon, onClick }) {

    let iconCloned;
    if (icon) {
        iconCloned = React.cloneElement(icon);
    }

    return (
        <div styleName="btn" onClick={onClick}>
            {iconCloned}
        </div>
    );

}

RoundButton.propTypes = {
    icon: PropTypes.element,
    onClick: PropTypes.func
};

export default CSSModules(RoundButton, styles, { allowMultiple: true });
